// Application Insights configuration for React
import { ApplicationInsights, ITelemetryItem } from '@microsoft/applicationinsights-web';

const instrumentationKey = import.meta.env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY || '';

export const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
  },
});

export function initializeAppInsights() {
  if (instrumentationKey) {
    appInsights.loadAppInsights();
    // Add custom tags/properties to all telemetry
    appInsights.addTelemetryInitializer((envelope: ITelemetryItem) => {
      envelope.tags = {
        ...envelope.tags,
        'ai.cloud.role': 'react-frontend',
        'ai.environment': process.env.NODE_ENV,
      };
    });
  }
}
